// com.ic2.auth.mfa.MfaServiceI generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';
import { TotpSetupDTO } from '../entities/TotpSetupDTO';
import { LoginResponse } from '../entities/LoginResponse';
import { MfaStatusDTO } from '../entities/MfaStatusDTO';
import { TotpEnrolmentDTO } from '../entities/TotpEnrolmentDTO';

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  private irpc = inject(IRPC);

  beginTotpSetup = (currentCode: string): RpcRequestBuilder<TotpSetupDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.beginTotpSetup';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(currentCode, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.auth.mfa.TotpSetupDTO');
  };

  beginTotpSetupAtLogin = (): RpcRequestBuilder<TotpSetupDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.beginTotpSetupAtLogin';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.auth.mfa.TotpSetupDTO');
  };

  confirmTotpSetup = (code: string): RpcRequestBuilder<string[]> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.confirmTotpSetup';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'java.util.List');
  };

  confirmTotpSetupAtLogin = (code: string): RpcRequestBuilder<TotpEnrolmentDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.confirmTotpSetupAtLogin';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.auth.mfa.TotpEnrolmentDTO');
  };

  disableTotp = (code: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.disableTotp';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  getStatus = (): RpcRequestBuilder<MfaStatusDTO> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.getStatus';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.auth.mfa.MfaStatusDTO');
  };

  regenerateBackupCodes = (code: string): RpcRequestBuilder<string[]> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.regenerateBackupCodes';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'java.util.List');
  };

  resendEmailCode = (): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.resendEmailCode';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  verifyBackupCode = (code: string): RpcRequestBuilder<LoginResponse> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.verifyBackupCode';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.services.dto.LoginResponse');
  };

  verifyEmailCode = (code: string): RpcRequestBuilder<LoginResponse> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.verifyEmailCode';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.services.dto.LoginResponse');
  };

  verifyTotp = (code: string): RpcRequestBuilder<LoginResponse> => {
    const req = new JSONRpcRequest();
    req.method = 'MfaService.verifyTotp';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(code, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.services.dto.LoginResponse');
  };

}
